<template>
  <div>
    <div class="mb-7 pa-3">
      <StudentFilter @onFilterChanged="val => updatePagination('page', 1, val)" />
    </div>
    <v-card>
      <v-data-table
        mobile-breakpoint="0"
        item-key="id"
        :items-per-page="5"
        :server-items-length="totalCount"
        :headers="headers"
        :items="items"
        sort-by="name"
        v-bind="this.$attrs"
        loading-text="Đang Tải"
        :loading="loading"
        disable-sort
        :hide-default-footer="!items[0]"
        @update:page="val => updatePagination('page', val)"
        @update:items-per-page="val => updatePagination('itemsPerPage', val)"
      >
        <template v-slot:[`item.student`]="{ item }">
          <CardStudentName :student="item.student" link />
        </template>
        <template v-slot:[`item.dob`]="{ item }">
          {{ item.student.dob | ddmmyyyy }}
        </template>
        <template v-slot:[`item.currentClass`]="{ item }">
          <router-link
            style="text-decoration: none"
            :to="'/class/' + (item.student.currentClass && item.student.currentClass.id)"
          >
            <span v-if="item.student.currentClass">{{ item.student.currentClass.title }}</span>
          </router-link>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          {{ item.createdAt | ddmmyyyy }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title style="cursor: pointer; color: red" @click="leftClub(item.id)">
                  Huỷ đăng ký</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import StudentFilter from './StudentFilter.vue'
import { headers } from './data'
import { Club } from '@/plugins/api'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  components: {
    CardStudentName,
    StudentFilter
  },
  data() {
    return {
      pagination: {},
      pageText: '',
      defaultQuery: {
        club: this.$route.params.id,
        isOpen: true
      }
    }
  },

  computed: {
    ...mapState({
      items: state => state.clubStudent.items,
      totalCount: state => state.clubStudent.totalCount,
      loading: state => state.clubStudent.loading
    }),
    headers() {
      return headers
    }
  },
  mounted() {
    this.fetch({ ...this.defaultQuery, _limit: 5, _start: 0 })
    this.count(this.defaultQuery)
  },
  methods: {
    ...mapActions({
      fetchOneClub: 'club/fetchOne',
      fetch: 'clubStudent/fetch',
      count: 'clubStudent/count',
      delete: 'clubStudent/delete'
    }),
    ...mapMutations({
      setState: 'clubStudent/setState'
    }),
    async updatePagination(type, val, params = {}) {
      this.setState({ atr: 'loading', value: true })
      try {
        const page = type === 'page' ? val : 1
        const itemsPerPage = type === 'itemsPerPage' ? val : 5
        await this.fetch({
          ...params,
          ...this.defaultQuery,
          _start: type === 'itemsPerPage' ? 0 : (page - 1) * itemsPerPage,
          _limit: itemsPerPage
        })
      } finally {
        this.setState({ atr: 'loading', value: false })
      }
    },
    leftClub(id) {
      this.$dialog.confirm({
        title: 'Xác nhận huỷ đăng ký câu lạc bộ',
        text: 'Sau khi huỷ đăng ký học sinh này sẽ không thể tham gia các hoạt động của câu lạc bộ nữa',
        okText: 'Xác nhận',
        cancelText: 'Huỷ',
        type: 'delete',
        done: async () => {
          try {
            this.$loading.active = true
            await Club.leftClub(this.$route.params.id, { clubStudentId: id })
            this.$alert.deleteSuccess()
            this.fetchOneClub(this.$route.params.id)
            this.fetch({ ...this.defaultQuery, _limit: 5, _start: 0 })
            this.count(this.defaultQuery)
          } catch (error) {
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  }
}
</script>
